import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

const Icon = ({ icon, iconType, ...rest }) => {
  return <IconWrapper icon={[iconType || 'fal', icon]} {...rest} />
}

export default Icon

const IconWrapper = styled(FontAwesomeIcon)`
  z-index: inherit;
`
